<script lang="ts">
	//UI
	import { Card } from "@hitit/new_ui";
	//Utils
	//Types
	//Props
	export let title = ``;
	export let date = "";
	export let article = "";
	//Constants
	//Variables
	//Functions
	//Do
</script>

<Card noPadding>
	<div class="container" id="Notice-reader">
		<slot name="control" />
		<div class="header">
			<h1 class="title">{title}</h1>
			{#if $$slots.additonal}
				<slot name="additonal" />
			{:else}
				<span class="date"> {date} </span>
			{/if}
		</div>
		<div class="seperate-bar" />
		<div class="body" id="HITIT-wiswig">
			{@html article}
		</div>
	</div>
</Card>

<style lang="scss">
	@import "../../../variables.scss";
	.container {
		display: flex;
		width: 100%;
		flex-direction: column;
		box-sizing: border-box;
		padding: 20px 10px;
		position: relative;
		.header {
			display: flex;
			flex-direction: column;
			gap: 10px;
			word-break: break-all;
			.title {
				font-weight: 500;
				font-size: 1.25rem;
				color: #46474b;
				line-height: 1.5625rem;
			}

			.date {
				margin-left: auto;
				color: #46474b;
			}
		}

		.seperate-bar {
			margin: 10px 0px;
		}

		.body {
			max-width: 100%;
		}
		.seperate-bar {
			height: 1px;
			background-color: #d3d4da;
		}
	}
	@include DesktopSize {
		.container {
			padding: 30px;

			.header {
				.title {
					font-size: 1.5rem;
					line-height: 2.1875rem;
				}
				.date {
					font-size: 1.25rem;
				}
			}
			.seperate-bar {
				margin: 10px 0px 20px 0px;
			}
		}
	}
</style>
